import { forwardRef } from "react";
import { classNames } from "utils";

interface SearchInputProps {
  value: string | undefined;
  onChange: ((value: string) => void) | Function;
  onClear?: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value,
      onChange,
      onClear,
      placeholder = "Search",
      className = "",
      disabled = false,
      id = "search",
      name = "search",
    },
    ref
  ) => {
    const handleClear = () => {
      if (typeof onChange === "function") {
        onChange("");
      }
      onClear && onClear();
    };

    const handleChange = (newValue: string) => {
      if (typeof onChange === "function") {
        onChange(newValue);
      }
    };

    const currentValue = value || "";

    return (
      <div
        className={classNames(
          "relative inline-flex rounded-xl shadow-sm w-96",
          className
        )}
      >
        <input
          type="text"
          name={name}
          id={id}
          ref={ref}
          placeholder={placeholder}
          value={currentValue}
          disabled={disabled}
          onChange={(e) => handleChange(e.target.value)}
          className={classNames(
            "relative inline-flex items-center border border-gray-300 bg-white px-6 py-4 text-base font-medium text-gray-700 focus:z-10 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 shadow-sm w-full h-12",
            currentValue && !disabled ? "rounded-l-lg" : "rounded-xl",
            disabled
              ? "bg-gray-50 text-gray-500 cursor-not-allowed"
              : "hover:bg-gray-50"
          )}
        />
        {currentValue && !disabled && (
          <button
            type="button"
            onClick={handleClear}
            className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-4 text-base font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 -ml-px h-12"
          >
            <span className="sr-only">Clear search</span>
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
